var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "root", staticClass: "wkb-graph-view-options" }, [
    _c(
      "button",
      {
        staticClass: "wkb-graph-control-btn wkb-graph-view-options-trigger",
        class: { "is-open": _vm.open },
        attrs: {
          type: "button",
          title: "View",
          "aria-label": "View",
          "aria-haspopup": "menu",
          "aria-expanded": _vm.open ? "true" : "false",
          "aria-controls": _vm.menuId,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.toggleOpen.apply(null, arguments)
          },
        },
      },
      [_c("b-icon", { attrs: { icon: "eye-fill", "aria-hidden": "true" } })],
      1
    ),
    _vm.open
      ? _c(
          "div",
          {
            staticClass: "wkb-graph-view-options-menu",
            attrs: { id: _vm.menuId, role: "menu", "aria-label": "View" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
              mousedown: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("p", { staticClass: "wkb-graph-view-options-menu-title" }, [
              _vm._v("Graph options"),
            ]),
            _c(
              "label",
              {
                staticClass: "wkb-graph-view-options-item",
                attrs: { role: "menuitemcheckbox" },
              },
              [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.hideContextualEdges },
                  on: {
                    change: function ($event) {
                      $event.stopPropagation()
                      return _vm.onHideContextualEdgesChange.apply(
                        null,
                        arguments
                      )
                    },
                  },
                }),
                _vm._v(" Hide contextual edges "),
              ]
            ),
            _c(
              "label",
              {
                staticClass: "wkb-graph-view-options-item",
                attrs: { role: "menuitemcheckbox" },
              },
              [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.hideJumpingEdges },
                  on: {
                    change: function ($event) {
                      $event.stopPropagation()
                      return _vm.onHideJumpingEdgesChange.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" Hide jumping edges "),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }